/***  Youtube Specific Functions */

export function loadYoutubeScript() {
    if (!window['YT']) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
}

export function onYoutubePlayerReady(event: any) {
    if (this.video.openInModal === 'true') {
        this.loadingComplete = true;
        event.target.playVideo();
        event.target.h.contentWindow.focus();
    } else {
        event.target.playVideo();
        event.target.h.contentWindow.focus();
    }
}